import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { listProducts, pricesOnDate } from "./productsApi";
import { productSellingPricesQueryKey } from "./useProductSellingPrices";

export const useProducts = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, error } = useQuery({
    queryKey: ["products"],
    queryFn: ({ signal }) => listProducts(signal),
  });

  useEffect(() => {
    if (!isLoading && error) {
      enqueueSnackbar(`Nie udało się pobrać listy produktów. Powód: ${error.message}`, {
        variant: "error",
      });
    }
  }, [isLoading, error]);

  return {
    products: data ?? [],
    isLoading,
  };
};

export function usePricesOnDate(date: string): { prices: { [productId: string]: number }; isLoading: boolean } {
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, error } = useQuery({
    queryKey: productSellingPricesQueryKey("*", { dateFrom: date, dateTo: date, participantsNumber: -1 }),
    queryFn: ({ signal }) => pricesOnDate(date, signal),
  });

  useEffect(() => {
    if (!isLoading && error) {
      enqueueSnackbar(`Nie udało się pobrać cen. Powód: ${error.message}`, {
        variant: "error",
      });
    }
  }, [isLoading, error]);

  return {
    prices: data ?? {},
    isLoading,
  };
}
